import React, { useMemo } from 'react';
import propTypes from 'prop-types';
import { UiTable } from 'src/ui';
import dayjs from 'dayjs-ext';
import { DATE_DAY_SMONTH_YEAR } from 'src/ui/const';

export function MetrcReceiptTable({ loading, paging, metrcReceipts }) {
  const tableColumns = useMemo(
    () => [
      {
        Header: 'Receipt Number',
        accessor: 'receiptNumber',
        Cell: row => <div>{row.value}</div>,
      },
      {
        Header: 'Sales Time',
        accessor: 'salesTime',
        width: 140,
        Cell: row => (
          <>
            {dayjs(row.value)
              .utc()
              .format(DATE_DAY_SMONTH_YEAR)}
          </>
        ),
      },
      {
        Header: 'Customer Type',
        accessor: 'customerType',
        Cell: row => <div>{row.value}</div>,
      },
      {
        Header: 'Package Count',
        accessor: 'packages',
        Cell: row => <div>{row.value}</div>,
      },
      {
        Header: 'Price',
        accessor: 'price',
        Cell: row => <div>{row.value}</div>,
      },
      {
        Header: 'Recorded By',
        accessor: 'recordedBy',
        Cell: row => <div>{row.value}</div>,
      },
    ],
    []
  );

  return (
    <>
      <UiTable
        className="metrc-receipt-table"
        columns={tableColumns}
        loading={loading}
        paging={paging}
        data={metrcReceipts}
        getTheadThProps={() => ({
          className: 'has-text-left',
        })}
        title="Metrc Receipts"
        hideNext
        hidePrev
        hideNoDataComponent
        minRows={1}
      />
    </>
  );
}

MetrcReceiptTable.propTypes = {
  loading: propTypes.bool.isRequired,
  paging: propTypes.object.isRequired,
  metrcReceipts: propTypes.arrayOf(propTypes.object).isRequired,
};
